"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('react'),
    useCallback = _require.useCallback,
    useMemo = _require.useMemo,
    useRef = _require.useRef;

try {
  var ReactRouterDom = require('react-router-dom'); // 从 react-router-dom@6 开始具备 useSearchParams


  if (ReactRouterDom.useSearchParams) {
    module.exports = ReactRouterDom.useSearchParams;
  } else if (ReactRouterDom.useHistory) {
    // 如果不存在，则用 v5.1 的 useHistory 和 useLocation 实现

    /**
     * A convenient wrapper for reading and writing search parameters via the
     * URLSearchParams interface.
     */
    var useSearchParams = function useSearchParams(defaultInit) {
      var history = ReactRouterDom.useHistory();
      var defaultSearchParamsRef = useRef(createSearchParams(defaultInit));
      var location = ReactRouterDom.useLocation();
      var searchParams = useMemo(function () {
        var searchParams = createSearchParams(location.search);

        var _iterator = _createForOfIteratorHelper(defaultSearchParamsRef.current.keys()),
            _step;

        try {
          var _loop = function _loop() {
            var key = _step.value;

            if (!searchParams.has(key)) {
              defaultSearchParamsRef.current.getAll(key).forEach(function (value) {
                searchParams.append(key, value);
              });
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return searchParams;
      }, [location.search]);
      var setSearchParams = useCallback(function (nextInit) {
        history.push({
          search: '?' + createSearchParams(nextInit)
        });
      }, [history]);
      return [searchParams, setSearchParams];
    };

    module.exports = useSearchParams;
  } else {
    // 如果没有 useHistory，说明版本不对
    throw 'Dependency requirements not met';
  }
} catch (e) {
  var alreadyWarned = false;

  module.exports = function () {
    if (!alreadyWarned) {
      console.warn('useSearchParams requires react-router-dom@^5.1.0||^6.0.0 to work correctly, but none was installed.');
      alreadyWarned = true;
    }

    return [new URLSearchParams(location.search), function () {}];
  };
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */


function createSearchParams() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new URLSearchParams(typeof init === 'string' || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function (memo, key) {
    var value = init[key];
    return memo.concat(Array.isArray(value) ? value.map(function (v) {
      return [key, v];
    }) : [[key, value]]);
  }, []));
}